export class MenuFontSizeList {
  static list = ['10px', '12px', '14px', '16px', '18px', '24px', '32px'];
  static default = '14px';
}
